// extracted by mini-css-extract-plugin
export default {"whyTriton":"WeHelp_whyTriton__CGHYq","tritonFocus":"WeHelp_tritonFocus__f4G5t","imageBlock":"WeHelp_imageBlock__Iu5rd"};